var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer-component-container"},[_c('div',{staticClass:"text"},[_c('div',[_vm._v("TIMER")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.formattedTime))])]),_vm._v(" "),_c('pie',{attrs:{"fill":_vm.pie}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }